import React, { Component } from 'react';

//styles
import './GallerySection.scss';

import '../../static/fonts/opensanshebrew/stylesheet.css'
import '../../static/fonts/Rubik/stylesheet.css';
import galleryData from '../../data/galleryData.json'
import { GA_Event } from '../Analytics/Analytics'
import { scrollTo, scrollDown } from '../../static/scrollAnimation'
import { isMobile, isIos } from '../../static/helper'

const YouTubeSvg = (props) => {
    return (
        <div className="youtube">
            <svg xmlns="http://www.w3.org/2000/svg" width="33.103" height="24" viewBox="0 0 33.103 24">
                <defs>
                </defs>
                <g id="yt_ic" transform="translate(-10 -973.361)">
                    <path id="Path_3121" d="M15.793 973.362A5.78 5.78 0 0 0 10 979.155v12.414a5.78 5.78 0 0 0 5.793 5.793H37.31a5.781 5.781 0 0 0 5.793-5.793v-12.414a5.78 5.78 0 0 0-5.793-5.793zm7.448 6.621l9.1 5.379-9.1 5.379z" className="cls-1" data-name="Path 3121" />
                </g>
            </svg>
        </div>
    )
}

class GallerySection extends Component {
    constructor() {
        super();
        this.handleHover = this.handleHover.bind(this);
        this.handleLeave = this.handleLeave.bind(this);
        this.state = {
            hoverdIdx: 0,
            innerContainerPosition: 0
        }
    }

    handleHover(idx) {

        this.setState(prevState => ({
            hoverdIdx: idx,
        }));
    }

    handleLeave() {
        if (!this.props.isYouTubeModalOpen) {
            this.setState({
                hoverdIdx: 0
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (isMobile() || isIos()) {
            if (this.state.hoverdIdx > 0 && prevState.hoverdIdx != this.state.hoverdIdx) {
                setTimeout(() => {
                    let self = this.refs.active;
                    if (typeof self != "undefined") {
                        let offset = self.getBoundingClientRect();
                        let scroll = offset.top + window.scrollY;
                        // scrollTo(self.offsetTop, Math.abs(scroll - 60), 1250)

                        scrollDown(self.className, -50);
                    }
                }, 800)
            }
        }
    }

    render() {
        let images = [];
        for (let i = 0; i < galleryData.length; i++) {
            const isCurrentActive = this.state.hoverdIdx === galleryData[i].id;
            let divClass = isCurrentActive ? "images image" + galleryData[i].id + " active" : this.state.hoverdIdx > 0 ? "images image" + galleryData[i].id + " not-active" : "images image" + galleryData[i].id;
            let ref = isCurrentActive ? "active" : ""
            images.push(
                <div key={i} className={divClass} ref={ref} onMouseEnter={() => this.handleHover(galleryData[i].id)} onMouseLeave={this.handleLeave}>
                    <div className="title">{galleryData[i].title}</div>
                    {
                        isMobile() || isIos() ?
                        <div onClick={() => {isCurrentActive ? this.setState({hoverdIdx: 0}): this.handleHover} } className={`mobile-all-songs ${isCurrentActive ? "open" :""}`}>{isCurrentActive ? "סגור" :"לרשימת השירים"}</div>
                        : ""
                    }
                    <div className={isCurrentActive ? "active-container" : "active-container hidden"}>
                        <div className="year-table">
                            <div className={isCurrentActive ? `item year0` : "item hidden"}>
                                <div className="youtube header"></div>
                                <div className="year header">שנה</div>
                                <div className="singer header"> זמר/להקה</div>
                                <div className="song header">שיר</div>
                                <div className="place header">מקום</div>
                            </div>
                            {galleryData[i].years.map((item, index) => {
                                return (
                                    <div key={index} onClick={() => this.props.openYouTubeModal(item.videoId)} className={isCurrentActive ? `item year${item.id}` : "item hidden"}>
                                        <YouTubeSvg />
                                        <div className="year">{item.year} {isMobile() || isIos()? <YouTubeSvg /> : ""}</div>
                                        <div className="singer">{item.singer}</div>
                                        <div className="song">{item.song}</div>
                                        <div className={item.place === "1" ? "place win" : "place"}>{item.place !== "1" ? item.place : ""}</div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            );

        }
        return (
            <div id="gallery-section" className={this.state.hoverdIdx > 0 ? "gallery-section open" : "gallery-section"}>
                <div className="gallery-section-container">
                    <div className="heart"></div>
                    <div className="desc-container">
                        <h2 className="title">ישראל באירוויזיון</h2>
                        <div className="desc">כל השירים והזמרים הישראלים שזכו לייצג אותנו במשך השנים</div>
                    </div>

                    <div className="accordion-container" >
                        {images}
                    </div>
                </div>
            </div>
        );
    }
}

export default GallerySection;


// WEBPACK FOOTER //
// ./src/Components/GallerySection/GallerySection.js